import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const MenuCategoryModelSchema = z
  .object({
    id: z.string(),
    menu_section_id: z.string(),
    name: z.string(),
    sequence: z.number()
  })
  .strict()

const MenuCategoryModelFields = makeFieldKeys(MenuCategoryModelSchema)

type MenuCategoryModel = z.infer<typeof MenuCategoryModelSchema>
